<h4 class="page-title" data-cy="page-title">
  {{ content() }}
</h4>
